(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const mediaRoot = document.querySelector('[data-media-root]');
    if (!mediaRoot) return;

    const DELAY = 5000;
    const nextBtn = mediaRoot.querySelector('.thumb-next');
    const thumbsList = mediaRoot.querySelector('[data-media-thumbs]');
    if (!nextBtn || !thumbsList) return;

    let timer = null;
    let isAutoAdvancing = false;

    const isCurrentVideo = () => {
      const type =
        mediaRoot.querySelector('[data-thumb].is-active-thumb')?.dataset.type ??
        '';
      return type === 'video' || type === 'external_video';
    };

    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!isCurrentVideo()) {
          isAutoAdvancing = true;
          nextBtn.dispatchEvent(
            new MouseEvent('click', { bubbles: true, cancelable: true })
          );
          setTimeout(() => {
            isAutoAdvancing = false;
          }, 50);
        }
        schedule();
      }, DELAY);
    };

    const resetOnUserAction = () => {
      if (isAutoAdvancing) return;
      clearTimeout(timer);
      requestAnimationFrame(schedule);
    };

    mediaRoot.addEventListener('click', resetOnUserAction);

    const observer = new MutationObserver(() => {
      if (isAutoAdvancing) return;
      resetOnUserAction();
    });

    observer.observe(thumbsList, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    schedule();
  });
})();
